import { setupGlobalAxiosDefaults } from 'services/settings/globalAxiosSettings';

const settings = {
  setupGlobalAxiosDefaults,
};

export default settings;
